import { StyleSheet, Platform } from 'react-native'

import { colors, backgroundColors, typography } from '@sart/styles'

const title = StyleSheet.create({
  style: {
    color: colors.white,
    ...typography.extrabold
  }
})

const description = StyleSheet.create({
  style: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi
  }
})

const button = StyleSheet.create({
  style: {
    backgroundColor: backgroundColors.brightOrange,
  },
  disabledStyle: {
    backgroundColor: backgroundColors.brightOrange + 60,
  },
})

const _dateInput = StyleSheet.create({
  dayStyle: {
    flex: 1,
    marginRight: 10,
    color: colors.srTextInput,
    backgroundColor: backgroundColors.white,
    borderRadius: 16,
    maxWidth: 192
  },
  monthStyle: {
    flex: 1,
    color: colors.srTextInput,
    backgroundColor: backgroundColors.white,
    borderRadius: 16,
    maxWidth: 192
  },
  yearStyle: {
    flex: 1,
    marginLeft: 10,
    color: colors.srTextInput,
    backgroundColor: backgroundColors.white,
    borderRadius: 16,
    maxWidth: 192
  },
  labelStyle: {
    color: colors.brightOrange,
    ...typography.demi
  },
  errorStyle: {
    color: colors.error,
    borderColor: colors.error
  },
  footerErrorStyle: {
    color: colors.error,
    textAlign: 'left'
  }
})

const dateInput = {
  yearStyle: _dateInput.yearStyle,
  monthStyle: _dateInput.monthStyle,
  dayStyle: _dateInput.dayStyle,
  labelStyle: _dateInput.labelStyle,
  placeholderTextColor: colors.srPlaceholder,
  errorStyle: _dateInput.errorStyle,
  footerErrorStyle: _dateInput.footerErrorStyle
}

const _textInput = StyleSheet.create({
  style: {
    color: colors.srTextInput,
    backgroundColor: backgroundColors.white,
    height: 48,
    borderRadius: 16
  },
  focusedStyle: {
    color: colors.srTextInput,
  },
  labelStyle: {
    color: colors.brightOrange,
    ...typography.demi
  },
  errorStyle: {
    color: colors.error,
    borderColor: colors.error
  },
  footerErrorStyle: {
    color: colors.error,
  },
  footerStyle: {
    color: colors.white
  }
})

const _textInputWhiteBackground = StyleSheet.create({
  style: {
    color: colors.srTextInput,
    backgroundColor: backgroundColors.white,
    height: 48,
    borderRadius: 16,
    borderColor: colors.brightOrange
  },
  focusedStyle: {
    color: colors.srTextInput,
  },
  labelStyle: {
    color: colors.srGreen,
    ...typography.demi
  },
  errorStyle: {
    color: colors.error,
    borderColor: colors.error
  },
  footerErrorStyle: {
    color: colors.error,
  },
  footerStyle: {
    color: colors.srDarkGreen
  }
})

const textInput = {
  selectionColor: colors.common,
  placeholderTextColor: colors.srPlaceholder,
  style: _textInput.style,
  focusedStyle: _textInput.focusedStyle,
  labelStyle: _textInput.labelStyle,
  errorStyle: _textInput.errorStyle,
  footerErrorStyle: _textInput.footerErrorStyle,
  footerStyle: _textInput.footerStyle,
  ...typography.demi
}

const textInputWhiteBackground = {
  selectionColor: colors.common,
  placeholderTextColor: colors.srPlaceholder,
  style: _textInputWhiteBackground.style,
  focusedStyle: _textInputWhiteBackground.focusedStyle,
  labelStyle: _textInputWhiteBackground.labelStyle,
  errorStyle: _textInputWhiteBackground.errorStyle,
  footerErrorStyle: _textInputWhiteBackground.footerErrorStyle,
  footerStyle: _textInputWhiteBackground.footerStyle,
  ...typography.demi
}

const _selectStyle = StyleSheet.create({
  containerStyle: {
    borderWidth: 1,
    backgroundColor: backgroundColors.white,
    color: colors.srTextInput,
    borderRadius: 4
  },
  labelStyle: {
    color: colors.srGreen,
    ...typography.bold
  },
  pickerStyle: {
    color: colors.srGreen
  }
})

const _selectStyles = StyleSheet.create({
  containerStyle: {
    borderWidth: 1,
    backgroundColor: backgroundColors.white,
    color: colors.srTextInput,
    borderColor: colors.srGreen,
    borderRadius: 4
  },
  labelStyle: {
    color: colors.clear,
    ...typography.bold
  },
  pickerStyle: {
    color: colors.srDarkGreen
  },
  style: {
    color: colors.black,
    ...Platform.select({
      web: {
        backgroundColor: backgroundColors.srGreen,
      },
      ios: {
        backgroundColor: backgroundColors.white,
      },
      android: {
        backgroundColor: backgroundColors.srGreen,
      }
    }),
    borderColor: '#FFA66F'
  }
})

const select = {
  selectionColor: colors.srGreen,
  placeholderTextColor: colors.white,
  style: _textInput.style,
  focusedStyle: _textInput.focusedStyle,
  labelStyle: _textInput.labelStyle,
  errorStyle: _textInput.errorStyle,
  footerErrorStyle: _textInput.footerErrorStyle,
  ...typography.demi
}

const selectIDStyle = {
  containerStyle: _selectStyles.containerStyle,
  focusedStyle: _textInput.focusedStyle,
  labelStyle: _textInput.labelStyle,
  errorStyle: _textInput.errorStyle,
  footerErrorStyle: _textInput.footerErrorStyle,
  ...typography.demi
}

const selectIDStyleBackgroundColour = {
  containerStyle: _selectStyles.containerStyle,
  style: _selectStyles.style,
  focusedStyle: _textInput.focusedStyle,
  labelStyle: _textInput.labelStyle,
  errorStyle: _textInput.errorStyle,
  footerErrorStyle: _textInput.footerErrorStyle,
  ...typography.demi
}

export {
  title,
  description,
  button,
  textInput,
  dateInput,
  select,
  selectIDStyle,
  selectIDStyleBackgroundColour,
  textInputWhiteBackground
}
